import { User } from 'oidc-client-ts';
import { IUserDetails } from '../types/IUserDetails';
import SessionStorageService from './SessionStorageService';

class UserIdentityService {
    public getAuthorizationHeaderValue(): string {
        const token = localStorage.getItem('user.access_token');        
        const tokentype = localStorage.getItem('user.token_type');
        if (token === '' || tokentype === '') {
            return '';
        }
        return `${tokentype} ${token}`;
    }

    public updateUserDetails(userDetails: IUserDetails) {
        localStorage.setItem('user.firstname', userDetails.firstname);
        localStorage.setItem('user.lastname', userDetails.lastname);
        localStorage.setItem('user.phone', userDetails.phone);
        localStorage.setItem('user.email', userDetails.email);
        localStorage.setItem('user.locale', userDetails.locale);
    }

    public setUserDataInLocalStorage(user: User) {
        if (user) {
            localStorage.setItem('user.access_token', user.access_token);
            localStorage.setItem('user.expires_at', user.expires_at?.toString() || '');
            localStorage.setItem('user.token_type', user.token_type);
            localStorage.setItem('user.id', user.profile.id as string);
            localStorage.setItem('user.roles', JSON.stringify(user.profile.roles));
            localStorage.setItem('user.firstname', user.profile.firstname as string || '');
            localStorage.setItem('user.lastname', user.profile.lastname as string || '');
            localStorage.setItem('user.phone', user.profile.phone_number || '');
            localStorage.setItem('user.email', user.profile.email || '');
            localStorage.setItem('user.locale', user.profile.locale || '');
        }
    }

    public GetUserId(): string {
        return localStorage.getItem('user.id') || '';
    }

    public getUserDetails(): IUserDetails {
        return {
            firstname: localStorage.getItem('user.firstname') || '',
            lastname: localStorage.getItem('user.lastname') || '',
            phone: localStorage.getItem('user.phone') || '',
            email: localStorage.getItem('user.email') || '',
            locale: localStorage.getItem('user.locale') || '',
        }
    }

    public getUserDisplayName = () => {
        const user = this.getUserDetails();
        return `${user.firstname} ${user.lastname}`;
    }

    public clearUserDataFromLocalAndSessionStorage = () => {
        localStorage.setItem('user.access_token', '')
        localStorage.setItem('user.expires_at', '')
        localStorage.setItem('user.firstname', '')
        localStorage.setItem('user.lastname', '')
        localStorage.setItem('user.email', '')
        localStorage.setItem('user.phone', '')
        localStorage.setItem('user.token_type', '')
        localStorage.setItem('user.id', '')
        localStorage.setItem('user.locale', '');
        localStorage.setItem('user.permissions', '');
        localStorage.setItem('user.roles', '');

        SessionStorageService.clear();
    }
}

export default new UserIdentityService();
